<template>
  <div>
    <dashboard-v2 v-if="(isManager || isPrincipal) && isPremier" />
  </div>
</template>

<script>
import DashboardV2 from '@/components/Performance/DashboardV2.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    DashboardV2,
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    ...mapGetters('userStore', [
      'isPremier',
      'isPrincipal',
      'isManager',
    ]),
  },
};

</script>

<style scoped lang="scss">

</style>
